import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import { useAppDispatch, useAppSelector } from "../../useStore";
import swal from 'sweetalert';
import { reset, sendForTranning } from "../../features/Applicant/applicantSlice";
import { Spinners } from "../TableOptions";
import { tranningOption } from "../JobInputData";
import ModalHeader from "../ModalHeader";
import { FormControl } from "@mui/material";
import moment from "moment";

const TranningStatus = ({ title, id, name, applicationId, recruiterID }) => {
  const { sendForTranningisSuccess, sendForTranningisError, sendForTranningisLoading, sendForTranningmessage } = useAppSelector((state: any) => state.applicant);
  const dispatch = useAppDispatch();

  const [welcome, setWelcome] = useState(false);
  const handleCloseWelcome = () => setWelcome(false);
  const handleWelcome = () => setWelcome(true);
  // const [startDate, setstartDate] = useState();
  // const [endDate, setendDate] = useState();

  // const [date, setDate] = useState({
	// 	startDate: '',
	// 	endDate: '',
	// })

  const [inputs, setInputs] = useState({
    recruiterID: "",
    trainingTitle: "",
    trainingStatus: "",
    startDate: "",
    endDate: "",
    applicationIds: ""
  });

  // const handleOnChange = (input: any, value: any) => {

	// 	// if (input === 'startDate') {
	// 	// 	setstartDate(value)
	// 	// }
	// 	// if (input === 'endDate') {
	// 	// 	setendDate(value)
	// 	// }
	// 	setInputs((prevState: any) => ({
	// 		...prevState,
	// 		[input]: value,
	// 	}));
	// };
  const handleOnChange = (input, value) => {
    setInputs((prevState) => ({
      ...prevState,
      [input]: input === "startDate" || input === "endDate" 
        ? moment(value).toISOString() // Convert date inputs to ISO format
        : value,
    }));
  };
  
  useEffect(() => {
    setInputs((prevState: any) => {
      return {
        ...prevState,
        recruiterID: recruiterID,
        applicationIds: applicationId,
        startDate: inputs.startDate ? moment(inputs.startDate).toISOString() : "",
				endDate: inputs.endDate ? moment(inputs.endDate).toISOString() : "",
      };
    });
  }, [applicationId, recruiterID, inputs.startDate, inputs.endDate]);






  useEffect(() => {
    if (sendForTranningisError) {
      swal({
        title: "error",
        text: sendForTranningmessage,
        icon: "error"
      })
      dispatch(reset())
    } else if (sendForTranningisSuccess) {
      swal({
        title: "success",
        text: "Applicant Sent For Tranning!",
        icon: "success"
      })
      setInputs({
        recruiterID: "",
        trainingTitle: "",
        trainingStatus: "",
        startDate: "",
        endDate: "",
        applicationIds: ""
      })
      setWelcome(false)
      dispatch(reset())
    }

  }, [dispatch,
    sendForTranningisError,
    sendForTranningisSuccess,
    sendForTranningmessage])


  const handleUpdate = () => {
    // @ts-ignore
    dispatch(sendForTranning(inputs));
  };


  return (
    <div>
      <div onClick={handleWelcome} className="more-button">
        {title}
      </div>

      <Modal show={welcome} onHide={handleCloseWelcome} centered>
        <ModalHeader setShow={setWelcome} headerTitle={"Training Status"} />
        <Modal.Body>
          <form>
            <div className="applicant-name">
              <h5>Applicant Name</h5>
              <p>{name}</p>
            </div>
            <div className="reviewer-name">
              <div>
                <h6 className="mt-4">Training Title</h6>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  className="round"
                  style={{ margin: "10px 0" }}
                  fullWidth
                  value={inputs?.trainingTitle}
                  onChange={(e) => handleOnChange("trainingTitle", e.target.value)}
                />
              </div>

              <div className='schedule-setting mt-3'>
                <FormControl fullWidth>
                  <h5>Start Date<span style={{ color: "red" }}> *</span></h5>
                  <TextField id="outlined-basic"
                    name='startDate'
                    type='date'
                    size="small"
                    required
                    style={{ width: "100%", margin: "10px 0", paddingRight: "10px" }}
                    variant="outlined"
                    value={inputs.startDate ? moment(inputs.startDate).format("YYYY-MM-DD") : ""}
                    onChange={(e) => handleOnChange("startDate", e.target.value)} />
                </FormControl>

                <FormControl fullWidth>
                  <h5>End Date</h5>
                  <TextField
                    required
                    id="outlined-basic"
                    name='endDate'
                    type='date'
                    size="small"
                    style={{ width: "100%", margin: "10px 0" }}
                    variant="outlined"
                    value={inputs.endDate ? moment(inputs.endDate).format("YYYY-MM-DD") : ""}
                    onChange={(e) => handleOnChange("endDate", e.target.value)}
                  />
                </FormControl>

              </div>

              <select className="round"
                value={inputs.trainingStatus}
                onChange={(e) => handleOnChange("trainingStatus", e.target.value)}>
                <option>Select Status</option>
                {tranningOption.map((item: any, i: any) => (
                  <option key={i} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>



          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseWelcome}>
            Cancel
          </Button>
          <Button id="primary" onClick={handleUpdate}>
            {sendForTranningisLoading ? <Spinners size={"sm"} /> : 'Send'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TranningStatus;